import React, {useEffect} from "react";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";
import IconosGenerales from "../iconos/IconosGenerales";
import Col from "react-bootstrap/Col";
import styled from "styled-components";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import ImagenDefault from "./../../img/imgDefault.png";
import { styled as muiStyled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import '../basicos/cardBlog.css';


function transformarTexto(texto) {
  return texto
    ?.normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-");
}

const CardCursos = ({ elementosLista, noReloj, categoria }) => {
   
useEffect(() => {
  const cards = document.querySelectorAll(".cardddd");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = 0;
          entry.target.style.animation = `aparecer 0.6s ease forwards`;
          entry.target.style.animationDelay = `${i * 0.3}s`;
        }
      });
    },
    { threshold: 0 }
  );

  cards.forEach((card) => observer.observe(card));

  return () => observer.disconnect();
}, [elementosLista]);

  console.log("elementosLista ", elementosLista);
  const CursosConSub = (elemento, index) => {
    return (
      <Columna lg="3" sm="12" md="4" key={elemento.Id}>
        <Link
          to={
            elemento.numCategorias
              ? `/cursos/${elemento.Categoria[0].urlCat}/${elemento.nombre.split("/").filter(Boolean).pop().toLowerCase().replace(/\s+/g, '-')}`
              : `/cursos/${elemento.url.replace(/^\/+/, '')}`
          }
          state={{ url_web: elemento.url }}
          style={{ textDecoration: "none" }}
        >
          <EstilosCards className="cardddd">
            <LazyLoad height={200} once>
              <Card.Img
                variant="top"
                src={elemento?.img ? elemento.img : ImagenDefault}
                onError={(e) => {
                  e.target.src = ImagenDefault;
                }}
              />
            </LazyLoad>

            <Card.Body>
              <Encabezado>
                <p>{categoria?.categoria?.categoria || categoria?.categoria || elemento?.Categoria[0]?.categoria || elemento?.Categoria?.categoria || "Sin categoría"}</p>
              </Encabezado>

              <BootstrapTooltip title={elemento.nombre.toUpperCase()} placement="top">
                <Link
                  to={
                    elemento.numCategorias
                      ? `/cursos/${elemento.Categoria[0].urlCat}/${elemento.nombre.split("/").filter(Boolean).pop().toLowerCase().replace(/\s+/g, '-')}`
                      : `/cursos/${elemento.url.replace(/^\/+/, '')}`
                  }
                  state={{ url_web: elemento.url }}
                  title={elemento.nombre.length > 30 ? elemento.nombre : ""}
                  style={{ fontSize: elemento.nombre.length > 30 ? "0.85rem" : "1rem" }}
                >
                  {elemento.nombre.toUpperCase()}
                </Link>
              </BootstrapTooltip>
            </Card.Body>

            {!noReloj && (
              <ListGroup className="list-group-flush">
                <ListGroup.Item>
                  <IconosGenerales id="reloj" /> {elemento.horas}
                </ListGroup.Item>
              </ListGroup>
            )}
          </EstilosCards>
        </Link>
      </Columna>
    );
  };

  return <>{elementosLista.map((elemento, index) => CursosConSub(elemento, index))}</>;
};

const BootstrapTooltip = muiStyled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));


const Columna = styled(Col)`
  margin-top: 5% !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EstilosCards = styled(Card)`
  text-align: left;
  width: 16.5rem !important;
  height: 24rem !important;
  
  p {
    text-transform: capitalize;
  }

  a {
  text-decoration: none;
  color: black;
  font-weight: bolder;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  font-size: 1rem; 
}

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    transition:  0.5s ease;
    a {
      color: #ee805d;
    }
  }

  .card-img-top {
    width: 100%;
    height: 12rem;
    object-fit: cover;
  }
`;



const Encabezado = styled.div`
  margin: -14px 0px 20px -14px !important;
  width: 16.3em;
  height: 40px;
  background-color: #f9f9f9;
  padding: 10px 15px;

  p {
    font-size: 16px;
    font-weight: 480;
  }
`;

export default CardCursos;
